var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGyAsy6IconsCmykBrakingWhtPrintAw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170.1 170.1",
    style: {
      enableBackground: "new 0 0 170.1 170.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BLUE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85,158.7c-40.6,0-73.7-33.1-73.7-73.7S44.4,11.3,85,11.3s73.7,33.1,73.7,73.7S125.7,158.7,85,158.7z M85,22.4 c-34.5,0-62.6,28.1-62.6,62.6s28.1,62.6,62.6,62.6s62.6-28.1,62.6-62.6S119.6,22.4,85,22.4z M85.1,46.8c-7.9,0-13.7,6.9-11.8,14.5 c3.2,12.7,6.6,25.3,10,38c0.2,0.6,1.2,1.4,1.8,1.3c0.6,0,1.6-0.8,1.8-1.4c3.4-12.7,6.6-25.3,9.9-38C98.6,53.9,92.8,46.8,85.1,46.8  M75.8,114.2c0,5.1,4,9,9.1,9c5.2,0,9.4-4.1,9.3-9.1c0-4.9-4.2-9-9.2-9C79.8,105,75.8,109,75.8,114.2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGyAsy6IconsCmykBrakingWhtPrintAw);
export default __webpack_public_path__ + "static/media/GY_ASY6_ICONS_CMYK_BRAKING_WHT_PRINT_AW.a36836659634e9ca212897ff242d4ea1.svg";
export { ForwardRef as ReactComponent };